import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Button, Icons, Modal, Stack, Text, styled } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

export const ImgMonitor = styled('img')(() => ({
  margin: 'auto',
  height: '40px',
  width: '36px',
}));

/**
 * This modal appears after the user monitors their first report, and gives basic info about monitoring.
 */
export function FirstReportMonitoredModal({
  isOpen,
  closeModal,
}: {
  isOpen: boolean;
  closeModal: () => void;
}) {
  const {
    images: { monitoringBell },
  } = useAppConstantsContext();
  const { isMobile } = useScreenSize();
  const {
    routingUtils: { navigate },
  } = useAppConfigContext();

  function goToMonitoring() {
    navigate('/dashboard/monitoring');
  }

  return (
    <Modal open={isOpen} sx={{ textAlign: 'center' }}>
      <ImgMonitor src={monitoringBell} sx={{ marginBottom: 2 }} />
      <Text variant="body1" fontWeight="bold" marginBottom={2}>
        Congratulations!
      </Text>
      <Text variant="h4" marginBottom={2}>
        You've just started monitoring your first report
      </Text>
      <Stack alignItems={isMobile ? 'flex-start' : 'center'}>
        <Stack direction="row" marginBottom={1}>
          <Icons.Check color="success" sx={{ marginRight: 2 }} />{' '}
          <Text>We'll alert you to any updates we detect</Text>
        </Stack>
        <Stack direction="row" marginBottom={1}>
          <Icons.Check color="success" sx={{ marginRight: 2 }} />{' '}
          <Text>Set up alert & email preferences in the monitoring tab</Text>
        </Stack>
        <Stack direction="row">
          <Icons.Check color="success" sx={{ marginRight: 2 }} />{' '}
          <Text>Turn monitoring off any time</Text>
        </Stack>
      </Stack>
      <Stack>
        <Button
          variant="contained"
          onClick={() => closeModal()}
          sx={{ marginTop: 4, marginBottom: 2 }}
          color="success"
        >
          Ok, got it
        </Button>
        <Button href="#" onClick={() => goToMonitoring()} color="success">
          Learn more
        </Button>
      </Stack>
    </Modal>
  );
}
